import navigateToNextOnboardingPageAction from '@actions/navigateToNextOnboardingPageAction'
import skipOnboardingLoader from '@app-studio-web/ui/loaders/skipOnboardingLoader'
import { Navigate, Outlet } from 'react-router-dom'
import BirthYearPage from './BirthYearPage'
import CravingTimesPage from './CravingTimesPage'
import DeviceDurationPage from './DeviceDurationPage'
import DisplayNamePage from './DisplayNamePage'
import FeedbackGreatToMeetYouPage from './FeedbackGreatToMeetYouPage'
import FeedbackImagineWhatYouCouldDoPage from './FeedbackImagineWhatYouCouldDoPage'
import FeedbackKnowledgeIsPowerPage from './FeedbackKnowledgeIsPowerPage'
import FeedbackTimeHealsPage from './FeedbackTimeHealsPage'
import FeedbackYouCanDoThisPage from './FeedbackYouCanDoThisPage'
import FeedbackYoureTakingControlPage from './FeedbackYoureTakingControlPage'
import GenderPage from './GenderPage'
import HardestPartPage from './HardestPartPage'
import HealthImprovementsPage from './HealthImprovementsPage'
import MorningRoutinePage from './MorningRoutinePage'
import PreviousQuitAttemptsPage from './PreviousQuitAttemptsPage'
import QuitGoalsPage from './QuitGoalsPage'
import QuitTimelinePage from './QuitTimelinePage'
import QuittingFeelingsPage from './QuittingFeelingsPage'
import SocialVapingPage from './SocialVapingPage'
import SupportSystemPage from './SupportSystemPage'
import VapeSpendingPage from './VapeSpendingPage'
import VapingDurationPage from './VapingDurationPage'
import VapingFrequencyPage from './VapingFrequencyPage'
import VapingStartAgePage from './VapingStartAgePage'
import VisitReasonPage from './VisitReasonPage'

const onboardingRoutes = [
  {
    path: '/onboarding',
    element: <Outlet />,
    loader: skipOnboardingLoader,
    children: [
      {
        element: <Navigate to="start" replace />,
        index: true,
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <GenderPage />,
        path: 'start',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <VisitReasonPage />,
        path: 'reason',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <FeedbackYouCanDoThisPage />,
        path: 'feedback-you-can-do-this',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <VapingDurationPage />,
        path: 'vaping-duration',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <VapingFrequencyPage />,
        path: 'vaping-frequency',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <VapingStartAgePage />,
        path: 'vaping-start-age',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <PreviousQuitAttemptsPage />,
        path: 'previous-quit-attempts',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <FeedbackYoureTakingControlPage />,
        path: 'feedback-youre-taking-control',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <CravingTimesPage />,
        path: 'craving-times',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <HardestPartPage />,
        path: 'hardest-part',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <SupportSystemPage />,
        path: 'support-system',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <FeedbackKnowledgeIsPowerPage />,
        path: 'feedback-knowledge-is-power',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <HealthImprovementsPage />,
        path: 'health-improvements',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <VapeSpendingPage />,
        path: 'vape-spending',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <DeviceDurationPage />,
        path: 'device-duration',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <QuitTimelinePage />,
        path: 'quit-timeline',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <FeedbackImagineWhatYouCouldDoPage />,
        path: 'feedback-imagine-what-you-could-do',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <MorningRoutinePage />,
        path: 'morning-routine',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <SocialVapingPage />,
        path: 'social-vaping',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <BirthYearPage />,
        path: 'birth-year',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <FeedbackTimeHealsPage />,
        path: 'feedback-time-heals',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <QuittingFeelingsPage />,
        path: 'quitting-feelings',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <QuitGoalsPage />,
        path: 'quit-goals',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <DisplayNamePage />,
        path: 'display-name',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <FeedbackGreatToMeetYouPage />,
        path: 'feedback-great-to-meet-you',
      },
    ],
  },
]

export default onboardingRoutes
